import { ReactNode } from "react";

type RuleBodyPageProps = {
  children: ReactNode;
  show: boolean;
};

function RuleBodyPage({ children, show }: RuleBodyPageProps) {
  return (
    <div
      className={`${show ? "" : "hidden"} flex flex-col gap-2 w-full text-sm`}
    >
      {children}
    </div>
  );
}

export default RuleBodyPage;
